// @ts-nocheck

(() => {
  const newsletter = document.querySelector('.newsletter-details');

  if (!newsletter) return;

  const footerGroups = document.querySelectorAll(
    '.shopify-section-group-footer-group'
  );

  if (!footerGroups.length) return;

  const observer = new IntersectionObserver(() => {
    const isAnyFooterVisible = [...footerGroups].some((group) => {
      const rect = group.getBoundingClientRect();

      return rect.top < window.innerHeight && rect.bottom > 0;
    });

    newsletter.style.display = isAnyFooterVisible ? 'none' : '';
  });

  footerGroups.forEach((group) => observer.observe(group));
})();